import { mapState } from 'vuex';
import {
  ApartmentDTO,
  EntrancePlantDetailDTO,
  GateGuestDTO,
} from '@/../client-generator/generated-clients/plants';
import plantsClient from '@/core/services/plants';
import { isCodeCorrectValue } from '@/core/utils/EntrancePlant/entrance-plant.utils';
import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';
import DialogShareCode from './DialogShareCode/DialogShareCode.vue';
@Options({
  name: 'CodeSection',
  components: {
    DialogShareCode
  },
  props: {
    apartment: {
      type: Object as PropType<ApartmentDTO>,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  watch: {
    keypadCode: function (value: string, oldValue: string) {
      if (value !== oldValue && this.keypadCodeEdited()) {
        this.resetValidation();
      }
    },
  },

  emits: ['onNewCodeEvent','onShareEmailEvent'],
})
export default class CodeSection extends Vue {
  
  editingGuest!: GateGuestDTO;
  currentEntrancePlant!: EntrancePlantDetailDTO;
  apartment!: ApartmentDTO;


  isEdit!: boolean;
  codeCheck: string = '';
  keypadCode: string = '';
  codeNotValid = false;
  codeValid = false;
  lengthNotValid = false;
  oldKeypadCode = '';

  isVisibleDialogEditLabel: boolean = false;

  updated() {
    if (this.editingGuest&& this.editingGuest.keypadCode) {
      this.oldKeypadCode = this.editingGuest.keypadCode;
      this.keypadCode = this.editingGuest.keypadCode;
      this.codeCheck = this.editingGuest.keypadCode;
    }
  }

  get enableConfirmation() {
    const enable = this.isCorrectValue;
    if (!enable) {
      this.codeCheck = '';
    }
    return enable;
  }

  get isCorrectValue() {
    return isCodeCorrectValue(
      this.keypadCode,
      this.currentEntrancePlant.keypadCodeRequiredLength
    );
  }

  get enableShare() {
    //TODO implement share
    return this.codeCheck !== '' && this.codeCheck === this.keypadCode;
  }

  get codeTabHasError() {
    const errorCodeValidation = this.codeCheck !== this.keypadCode;
    return errorCodeValidation;
  }


  checkCodeLength() {
    this.lengthNotValid = this.keypadCode !== '' && !this.isCorrectValue;
  }

  resetLengthValidation() {
    this.lengthNotValid = false;
  }

  checkCodeValid() {
    if (this.codeCheck.trim() !== '' || this.keypadCode.trim() !== '') {
      this.codeNotValid = this.codeCheck !== this.keypadCode;
      this.codeValid =
        this.isCorrectValue && this.codeCheck === this.keypadCode;
    }
  }

  resetValidation() {
    this.codeNotValid = false;
    this.codeValid = false;
  }

  keypadCodeEdited() {
    if (this.keypadCode !== '') {
      return (
        this.codeCheck === this.keypadCode &&
        this.keypadCode !== this.oldKeypadCode
      );
    } else {
      return this.keypadCode !== this.oldKeypadCode;
    }
  }

  checkOnConfirmUpdated() {
    if(this.codeCheck === this.keypadCode) {
      this.$emit("onNewCodeEvent", this.keypadCode)
    }
  }

  async codeGenerator() {
    this.resetValidation();
    this.resetLengthValidation();
    const randStr = await plantsClient.randomkeypadcode(
      this.currentEntrancePlant.keypadCodeRequiredLength as number
    );
    this.keypadCode = randStr.toString();
    this.codeCheck = this.keypadCode;
    this.$emit("onNewCodeEvent", this.keypadCode)
  }

  shareCode() {
    this.isVisibleDialogEditLabel = true;
   }

  mounted() {
    if(this.apartment)
      this.keypadCode = this.apartment.keypadCode!
  }

  async onShareEmail(email: string) {
    this.isVisibleDialogEditLabel = false;
    this.$emit("onShareEmailEvent",email)
  }
}
